<div class="d-flex flex-row kpi-report" *ngIf="kpi">
  <div class="flex-g1 kpi-report-item" *ngIf="kpi.mention.value != null && showMentionsKpi">
    <div class="content-shadow-box small-box mentions">
      <div class="d-flex flex-row kpi-report-item-label">
        <span class="flex-g1">{{'common.measure.kpi_name.mentions' | translate}}</span>
      </div>
      <div class="d-flex flex-row">
        <div class="flex-g1">
          <div class="kpi-report-item-number">
            <span placement="bottom"
                  ngbTooltip="{{'info_box.measure.kpi_mention' | translate}}">
              {{ kpi.mention.value | thousandNumberSuffix }}
            </span>
          </div>
        </div>
        <div class="flex-g1 d-flex justify-content-end">
          <div class="badge kpi-percentage {{kpi.mention.status}}" *ngIf="showKpiStatus">
            <div class="arrow-icon">
              <div class="kpi-upwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <desc></desc>
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-up">
                      <g id="Chevron-down">
                        <rect id="Transparent" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="20" height="20"></rect>
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="kpi-downwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-down" transform="rotate(0 10 10)">
                      <g id="Chevron-down">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <span>{{ kpi.mention.percent | percentNumberSuffix }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-g1 kpi-report-item" *ngIf="kpi.post.value != null">
    <div class="content-shadow-box small-box impressions">
      <div class="d-flex flex-row kpi-report-item-label">
        <span class="flex-g1">{{'common.measure.kpi_name.post' | translate}}</span>
      </div>
      <div class="d-flex flex-row">
        <div class="flex-g1">
          <div class="kpi-report-item-number"
               placement="bottom"
               ngbTooltip="{{'info_box.influencer.total_post' | translate}}">
            {{ kpi.post.value | thousandNumberSuffix }}
          </div>
        </div>
        <div class="flex-g1 d-flex justify-content-end">
          <div class="badge kpi-percentage {{kpi.post.status}}" *ngIf="showKpiStatus">
            <div class="arrow-icon">
              <div class="kpi-upwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <desc></desc>
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-up">
                      <g id="Chevron-down">
                        <rect id="Transparent" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="20" height="20"></rect>
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="kpi-downwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-down" transform="rotate(0 10 10)">
                      <g id="Chevron-down">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <span>{{ kpi.post.percent | percentNumberSuffix }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-g1 kpi-report-item kpi-impressions" *ngIf="kpi.impressions.value != null">
    <div class="content-shadow-box small-box impressions">
      <div class="d-flex flex-row kpi-report-item-label">
        <span *ngIf="!kpi.isAverage" class="flex-g1">{{'common.measure.kpi_name.impressions' | translate}}</span>
        <span *ngIf="kpi.isAverage" class="flex-g1">{{'common.measure.kpi_name.avg_impressions' | translate}}</span>
      </div>
      <div class="d-flex flex-row">
        <div class="flex-g1">
          <div class="kpi-report-item-number">
            <span placement="bottom"
                  ngbTooltip="{{getTooltipInfo('impression')}}">
              {{ kpi.impressions.value | thousandNumberSuffix }}
            </span>
          </div>
        </div>
        <div class="flex-g1 d-flex justify-content-end">
          <div class="badge kpi-percentage {{kpi.impressions.status}}" *ngIf="showKpiStatus">
            <div class="arrow-icon">
              <div class="kpi-upwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <desc></desc>
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-up">
                      <g id="Chevron-down">
                        <rect id="Transparent" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="20" height="20"></rect>
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="kpi-downwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-down" transform="rotate(0 10 10)">
                      <g id="Chevron-down">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <span>{{ kpi.impressions.percent | percentNumberSuffix }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-g1 kpi-report-item" *ngIf="kpi.reach.value != null">
    <div class="content-shadow-box small-box reach">
      <div class="d-flex flex-row kpi-report-item-label">
        <span *ngIf="!kpi.isAverage" class="flex-g1">
          {{'common.measure.kpi_name.reach' | translate}}
        </span>
        <span *ngIf="kpi.isAverage" class="flex-g1">
          {{'common.measure.kpi_name.avg_reach' | translate}}
        </span>
      </div>
      <div class="d-flex flex-row">
        <div class="flex-g1">
          <div class="kpi-report-item-number">
            <span placement="bottom"
                  ngbTooltip="{{getTooltipInfo('reach')}}">
              {{ kpi.reach.value | thousandNumberSuffix }}
            </span>
          </div>
        </div>
        <div class="flex-g1 d-flex justify-content-end">
          <div class="badge kpi-percentage {{kpi.reach.status}}" *ngIf="showKpiStatus">
            <div class="arrow-icon">
              <div class="kpi-upwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <desc></desc>
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-up">
                      <g id="Chevron-down">
                        <rect id="Transparent" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="20" height="20"></rect>
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="kpi-downwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-down" transform="rotate(0 10 10)">
                      <g id="Chevron-down">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <span>{{ kpi.reach.percent | percentNumberSuffix }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-g1 kpi-report-item" *ngIf="kpi.engagement.value != null">
    <div class="content-shadow-box small-box engagement">
      <div class="d-flex flex-row kpi-report-item-label">
        <span *ngIf="!kpi.isAverage"
              class="flex-g1">
          {{'common.measure.kpi_name.engagement' | translate}}
        </span>
        <span *ngIf="kpi.isAverage"
              class="flex-g1">
          {{'common.measure.kpi_name.avg_engagement' | translate}}
        </span>
      </div>
      <div class="d-flex flex-row">
        <div class="flex-g1">
          <div class="kpi-report-item-number">
            <span placement="bottom"
                  ngbTooltip="{{getTooltipInfo('engagement')}}">
            {{ kpi.engagement.value | thousandNumberSuffix }}
            </span>
          </div>
        </div>
        <div class="flex-g1 d-flex justify-content-end">
          <div class="badge kpi-percentage {{kpi.engagement.status}}" *ngIf="showKpiStatus">
            <div class="arrow-icon">
              <div class="kpi-upwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <desc></desc>
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-up">
                      <g id="Chevron-down">
                        <rect id="Transparent" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="20" height="20"></rect>
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="kpi-downwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-down" transform="rotate(0 10 10)">
                      <g id="Chevron-down">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <span>{{ kpi.engagement.percent | percentNumberSuffix }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-g1 kpi-report-item" *ngIf="kpi.impact.value != null">
    <div class="content-shadow-box small-box impact">
      <div class="d-flex flex-row kpi-report-item-label">
        <span *ngIf="!kpi.isAverage"
              class="flex-g1">
          {{'common.measure.kpi_name.impact' | translate}}
        </span>
        <span *ngIf="kpi.isAverage"
              class="flex-g1">
          {{'common.measure.kpi_name.avg_impact' | translate}}
        </span>
      </div>
      <div class="d-flex flex-row">
        <div class="flex-g1">
          <div class="kpi-report-item-number">
            <span placement="bottom"
                  ngbTooltip="{{getTooltipInfo('impact')}}">
              {{ kpi.impact.value | percentNumberSuffix }}
            </span>
          </div>
        </div>
        <div class="flex-g1 d-flex justify-content-end">
          <div class="badge kpi-percentage {{kpi.impact.status}}" *ngIf="showKpiStatus">
            <div class="arrow-icon">
              <div class="kpi-upwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <desc></desc>
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-up">
                      <g id="Chevron-down">
                        <rect id="Transparent" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="20" height="20"></rect>
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="kpi-downwards">
                <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
                  </defs>
                  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Keyicons/Chevron-down" transform="rotate(0 10 10)">
                      <g id="Chevron-down">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use id="Mask" fill="#717D8D" fill-rule="nonzero" xlink:href="#path-1"></use>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <span>{{ kpi.impact.percent | percentNumberSuffix }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/kpi-report/kpi-report.component.html